import React from "react";
import s from "./Rating.module.scss";

function Rating({ value = 5, max = 5 }) {
  return (
    <div className={s.rating}>
      {Array.from({ length: max }).map((_, i) => {
        const filled = i < value;
        return (
          <span
            key={i}
            className={`${s.star} ${filled ? s.filled : ""}`}
          >
            ★
          </span>
        );
      })}
    </div>
  );
}

export default Rating;
